export const AppSettings = {
  environment: process.env.REACT_APP_SETTINGS_ENVIRONMENT,
  apiUrl: process.env.REACT_APP_SETTINGS_API_URL,
  bdsName: "Bureau of Disabilities Services",
  bdsAcronym: "BDS",
  showFooterMenu: process.env.REACT_APP_SETTINGS_SHOW_FOOTER_MENU,
  activityPulseInterval: 10000,
  autoLogoutNotificationWindowInSeconds: 120
}